import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { useForm } from "react-hook-form";
import { fetchAPI } from "../service/Encrtyption";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { login, registerData } from "./redux/store";
import { useTranslation } from "react-i18next";
import { Loader } from "../loader";
import ReactGA from 'react-ga4';
import LoginBannerhi from "../../assets/images/HindiBanner.png";
import LoginBannermr from "../../assets/images/MarathiBanner.png";
import LoginBannerka from "../../assets/images/KannadaBanner.png";
import LoginBannerte from "../../assets/images/TeluguBanner.png";
import LoginBannerpb from "../../assets/images/PunjabiBanner.png";
import LoginBannergu from "../../assets/images/GujaratiBanner.jpg";
import LoginBannerta from "../../assets/images/tamilBanner.png";
import LoginBanneren from "../../assets/images/EnglishBanner.jpg";
import LoginBannerba from "../../assets/images/BanglaBanner.png";
import LoginBannerod from "../../assets/images/OdiyaBanner.png";
import { parseScanData } from "../../utils/parseScanData";
import CustomModal from "../modal";
import { Button } from "react-bootstrap";
import { getPrivacyConsentNotice } from "../../content/privacyConsentNotice";
import PrivacyConsentContent from "../pages/privacyConsent/PrivacyConsentContent";
import { OTP_VERIFY_INPUT_STYLES } from "./otpVerifyInput";
import Check from "../../assets/images/check.png";
import { getScanLimitNotice, isScanLimitReached } from "../../utils/genuityCheck";
import Wrongotp from "../../assets/images/wrongotp.png";

const LOGIN_CUSTOM_MODAL_STYLES = `
#consentDetailsModal .custom-modal__backdrop {
  background-color: rgba(0, 0, 0, 0.55) !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 100% !important;
  transform: none !important;
}

#consentDetailsModal .custom-modal__dialog {
  margin: 1rem auto !important;
}

#consentDetailsModal .custom-modal__content {
  text-align: left !important;
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22),
    0 4px 16px rgba(0, 0, 0, 0.12) !important;
  padding: 0 !important;
  overflow: hidden;
  min-height: 300px;
}

#consentDetailsModal.modal-lg .custom-modal__content {
  min-height: 420px;
}

#consentDetailsModal .consent-know-more-btn {
  background: none;
  border: 0;
  color: #009dff;
  cursor: pointer;
  display: inline;
  font-size: 12px;
  font-weight: 600;
  line-height: inherit;
  margin: 0 !important;
  padding: 0;
  text-decoration: underline;
  vertical-align: initial;
}

#consentDetailsModal .consent-check-text {
  color: #555;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  padding: 0 24px;
}

#consentDetailsModal .custom-modal__header {
  padding: 1rem 1.25rem !important;
  text-align: left !important;
  background-color: var(--secondary-color, #2bb24b) !important;
  border-radius: 16px 16px 0 0;
}

#consentDetailsModal .custom-modal__title {
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  text-align: left !important;
  color: #fff !important;
  line-height: 1.35;
}

 .consent-know-more-btn {
    background: none;
    border: 0;
    color: #009dff;
    cursor: pointer;
    display: inline;
    font-size: 12px;
    font-weight: 600;
    line-height: inherit;
    margin: 0 !important;
    padding: 0;
    text-decoration: underline;
    vertical-align: initial;
}

 .consent-check-text {
    color: #555;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    padding: 0 24px;
}

#consentDetailsModal .custom-modal__body {
  text-align: left !important;
  padding: 0.85rem 1.35rem 1.35rem !important;
}

#consentDetailsModal .custom-modal__footer {
  padding: 0 1.25rem 1.15rem !important;
}

 .consent-modal-footer-actions {
  display: flex;
  gap: 0.65rem;
  width: 100%;
}
`;

// const LOGIN_CUSTOM_MODAL_STYLES = `
// .custom-modal__backdrop {
//   background-color: rgba(0, 0, 0, 0.55) !important;
//   top: 0 !important;
//   left: 0 !important;
//   right: 0 !important;
//   width: 100% !important;
//   height: 100% !important;
//   transform: none !important;
// }

// .custom-modal__dialog {
//   margin: 1rem auto !important;
// }

// .custom-modal__content {
//   text-align: left !important;
//   border: none !important;
//   border-radius: 16px !important;
//   box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22), 0 4px 16px rgba(0, 0, 0, 0.12) !important;
//   padding: 0 !important;
//   overflow: hidden;
//   min-height: 300px;
// }

// .custom-modal .modal-lg .custom-modal__content {
//   min-height: 420px;
// }

//  .consent-know-more-btn {
//     background: none;
//     border: 0;
//     color: #009dff;
//     cursor: pointer;
//     display: inline;
//     font-size: 12px;
//     font-weight: 600;
//     line-height: inherit;
//     margin: 0 !important;
//     padding: 0;
//     text-decoration: underline;
//     vertical-align: initial;
// }

//  .consent-check-text {
//     color: #555;
//     cursor: pointer;
//     font-size: 12px;
//     font-weight: 400;
//     margin: 0;
//     padding: 0 24px;
// }

// .custom-modal__header {
//   padding: 1rem 1.25rem !important;
//   text-align: left !important;
//   background-color: var(--secondary-color, #2bb24b) !important;
//   border-radius: 16px 16px 0 0;
// }

// .custom-modal__title {
//   font-size: 1.05rem !important;
//   font-weight: 700 !important;
//   text-align: left !important;
//   color: #fff !important;
//   line-height: 1.35;
// }

// .custom-modal__header .close,
// .custom-modal__header .close img {
//   filter: brightness(0) invert(1);
// }

// .custom-modal__body {
//   text-align: left !important;
//   padding: 0.85rem 1.35rem 1.35rem !important;
//   min-height: 150px;
//   font-size: 0.9rem;
//   line-height: 1.55;
//   color: #333;
// }

// .custom-modal__body p,
// .custom-modal__body ul,
// .custom-modal__body ol,
// .custom-modal__body h6 {
//   text-align: left !important;
// }

// .custom-modal__body .text-center {
//   text-align: center !important;
// }

// .custom-modal__footer {
//   justify-content: stretch !important;
//   padding: 0 1.25rem 1.15rem !important;
//   gap: 0.65rem;
// }

// .custom-modal__footer > * {
//   width: 100%;
//   margin: 0 !important;
// }

// .custom-modal .privacy-consent-content--modal {
//   max-height: 58vh;
//   min-height: 220px;
//   overflow-y: auto;
//   padding-right: 0.35rem;
// }

// .custom-modal .modalInfo {
//   text-align: left !important;
// }

// .custom-modal .genuityCheckLimitMsg {
//   text-align: left !important;
// }

// .consent-modal-footer-actions {
//   display: flex;
//   gap: 0.65rem;
//   width: 100%;
// }

// .consent-modal-footer-actions .btn {
//   flex: 1;
//   margin: 0 !important;
//   width: auto !important;
// }

// .consent-modal-footer-actions .consent-decline-btn {
//   background-color: #fff !important;
//   color: #2bb24b !important;
//   border: 2px solid #2bb24b !important;
//   font-weight: 600;
// }

// .consent-modal-footer-actions .consent-decline-btn:hover,
// .consent-modal-footer-actions .consent-decline-btn:focus {
//   background-color: #f5f5f5 !important;
//   color: #0d5d29 !important;
//   border-color: #0d5d29 !important;
// }
// `;

export const Register = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const [GenunityCheckModal, setGenunityCheckModal] = useState(false);
  const [ErrorModalGenunity, setErrorModalGenunity] = useState(false);

  const scanResponseData = useSelector((state) => state?.genunityData);
  const scanLimitReached = isScanLimitReached(scanResponseData);
  const scanLimitNotice =
    getScanLimitNotice(scanResponseData) || scanResponseData.uq_message || t("genuityCheck.scanLimitFallback");


  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm();
  const REACT_APP_MAPS_API_KEY = "AIzaSyDSnvnrNEsJaOdNyzcOkLfjomZ8WVLiajw&libraries=places&callback";
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [lastsValue, setLastsValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [totalAcres, setTotalAcres] = useState('');
  const [consentModalShow, setConsentModalShow] = useState(false);

  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // const registration = useSelector((state) => state.registration);


  const mobileNumber = sessionStorage.getItem('mbn');
  const farmerName = sessionStorage.getItem('name');
  const [nameInput, setNameInput] = useState(farmerName || "");

  // const UserData = useSelector((state) => state.user);
  const scanedData = useSelector((state) => state?.scandataUrl);
  const parseData = parseScanData(scanedData) ?? {};
  // console.log("scanedData" + JSON.stringify(parseData));
  // alert("scanedData" + JSON.stringify(parseData.pincode)); 

  const [formErrors, setFormErrors] = useState({
    totalAcres: false
  });

  const [formData, setFormData] = useState({
    cepFlag: false,
    countryId: 5,
    customerType: "Farmer",
    deviceId: "",
    deviceToken: "",
    firstName: "",
    geolocation: "",
    languageId: "1",
    lastName: "",
    mobileNumber: mobileNumber,
    optInWhatsApp: false,
    pincode: "",
    referrer: "",
    rhrdFlag: false,
    villageLocation: "",
    wheatProgramFlag: false,
    destinationURL: "/customer/registerCustomer",
  });

  // const getCurrentLocation = () => {

  //   // debugger; 
  //   setLoading(true)
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const latitude = position.coords.latitude;
  //         const longitude = position.coords.longitude;
  //         setLatitude(latitude);
  //         setLongitude(longitude);
  //         const lats = `${latitude}, ${longitude}`;
  //         setLastsValue(lats);
  //         getAddressFromLatLng(latitude, longitude);
  //         setLoading(false);
  //       },
  //       (error) => {
  //         console.error("Error getting location:", error);
  //         if (error) {
  //           alert("user denied maps");
  //           navigate(`/${lang}/login`);
  //         }
  //       }
  //     );
  //   } else {
  //     console.log("Geolocation is not supported by this browser.");
  //   }
  // };

  // useEffect(() => {
  //   // window.addEventListener("load", () => {
  //   //   alert("Please allow location access to get your current location.");
  //   getCurrentLocation();
  //   // });
  // }, []);


  // const onSubmit = async () => {

  //   setLoading(true);
  //   ReactGA.event({
  //     category: 'User Register',
  //     action: 'CLK_REGISTER_BTN'
  //   });

  //   //debugger;
  //   try {
  //     const responseData = await fetchAPI(
  //       process.env.REACT_APP_API_URL,
  //       formData,
  //       {
  //         authKey: "",
  //         methodName: "",
  //         sharedWith: "",
  //       }
  //     );
  //     // console.log("jsonReposneDataOBJ"+JSON.stringify(formData));
  //     const jsonReposneData = JSON.parse(responseData);
  //     // console.log("jsonReposneData"+JSON.stringify(jsonReposneData));
  //     if (jsonReposneData.statusCode == 200 && jsonReposneData.otp) {
  //       dispatch(login(jsonReposneData));
  //       navigate(`/${lang}/login`);
  //     } else {
  //       setErrorMessage(jsonReposneData.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching API:", error);
  //     setErrorMessage(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handletotalAcresInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "totalAcres") {
      // Allow only digits and one decimal point
      let sanitizedValue = value.replace(/[^0-9.]/g, '');

      // Prevent multiple decimals
      const parts = sanitizedValue.split('.');
      if (parts.length > 2) {
        return;
      }

      // Limit digits before and after decimal
      let validValue = parts[0].slice(0, 3); // max 3 digits before decimal

      if (parts[1] !== undefined) {
        validValue += '.' + parts[1].slice(0, 2); // max 2 digits after decimal
      }

      // Disallow value if it's just 0 without decimal
      if (validValue === '0') {
        return;
      }

      e.target.value = validValue;
      setTotalAcres(validValue);

      if (validValue.length > 0) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          totalAcres: false,
        }));
      }

      clearErrors(validValue); // Pass current value
    }
  };


  //for profile Update
  const onSubmit = async (e) => {

    // debugger;

    let errors = {};

    if (!totalAcres) {
      errors = { ...errors, totalAcres: true };
    } else {
      errors = { ...errors, totalAcres: false };
    }

    setFormErrors(errors);

    if (!errors.totalAcres) {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL_GLOBAL}updateFarmerProfileWeb`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            mobileNumber: mobileNumber,
            firstName: nameInput,
            lastName: nameInput,
            emailId: "",
            riceCropAcres: "",
            groundNutCropAcres: "",
            soyabeanCropAcres: totalAcres,
            districtName: scanedData ? parseData.district : "",
            // villageName: scanedData ? parseData.village : "",
            villageName: "",
            type: "updateProfile",
            shareType: "",
          }),
        });

        const result = await response.json();
        // alert(JSON.stringify(result) + "updateProfileresult");
        if (result.statusCode === "200" || result.successCode === "200" ) {
          console.log(result.response);
          // alert("scanResponseData2" + JSON.stringify(scanResponseData));
          if (scanResponseData?.statusCode === '200' && scanResponseData?.uq_responseCode === "100") {
            if (scanResponseData.isAlreadyScannedProduct === true) {
              setErrorModalGenunity(true);
              return;
            } else {
              setGenunityCheckModal(true);
            }
          }
          // navigate(`/${lang}/rewardjourney`);
        } else {
          setErrorModalGenunity(true);
          // alert(result.message);
          // setErrorMessage(result.message);
        }
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const getAddressFromLatLng = (lat, lng) => {
    if (window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      const latLng = new window.google.maps.LatLng(lat, lng);
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            setAddress(results[0].formatted_address);
          } else {
            console.log("No results found");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      });
    } else {
      console.log("Google Maps API is not available.");
    }
  };

  const handleChange = (fieldName, value) => {
    setFormData((prevCrop) => ({
      ...prevCrop,
      [fieldName]: value,
      villageLocation: address,
      geolocation: lastsValue
    }));
    clearErrors(fieldName);
  };

  const handleKeyPress = (e) => {
    // debugger;
    // Get the keyCode of the pressed key
    const keyCode = e.keyCode || e.which;

    // Allow alphanumeric characters (a-z, A-Z, 0-9) and spaces (keyCode 32)
    const isAlphanumeric = (keyCode >= 65 && keyCode <= 90) || // A-Z
      (keyCode >= 97 && keyCode <= 122) || // a-z
      (keyCode >= 48 && keyCode <= 57) || // 0-9
      keyCode === 32; // Space

    // If the pressed key is not alphanumeric or space, prevent default behavior
    if (!isAlphanumeric) {
      e.preventDefault();
    }
  };

  const hide = () => {
    setErrorMessage(""); // Assuming you have a state to manage the error message
  };


  //change baneer based on the lang

  let bannerImageSrc;
  if (lang === 'hi') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'mr') {
    bannerImageSrc = LoginBannermr;
  } else if (lang === 'kn') {
    bannerImageSrc = LoginBannerka;
  } else if (lang === 'te') {
    bannerImageSrc = LoginBannerte;
  } else if (lang === 'pa') {
    bannerImageSrc = LoginBannerpb;
  } else if (lang === 'gu') {
    bannerImageSrc = LoginBannergu;
  } else if (lang === 'ta') {
    bannerImageSrc = LoginBannerta;
  } else if (lang === 'en') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'or') {
    bannerImageSrc = LoginBannerod;
  } else if (lang === 'bn') {
    bannerImageSrc = LoginBannerba;
  } else if (lang === 'ma') {
    bannerImageSrc = LoginBanneren;
  }
  else {
    bannerImageSrc = LoginBannerhi;
  }


  const openConsentModal = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setConsentModalShow(true);
  };

  const handleConsentAccept = async () => {
    setConsentModalShow(false);
  };

  const handleConsentDecline = () => {
    closeConsentModal();
  };

  const closeConsentModal = () => {
    setConsentModalShow(false);
  };


  const handleGenuityProceedCashback = () => {
    if (scanLimitReached) return;
    ReactGA.event({
      category: "User Proceed to Cashback",
      action: "Clicked the Proceed to Cashback Button",
    });
    setGenunityCheckModal(false);
    navigate(`/${lang}/rewardjourney`);
  };

  return (
    <>
      <style>{`${LOGIN_CUSTOM_MODAL_STYLES}\n${OTP_VERIFY_INPUT_STYLES}`}</style>

      <Header />

      <div className="main px-2 mt-3">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card px-0 border-0">
            <img
              src={bannerImageSrc}
              className="img-fluid w-100 shadow"
              alt="banner"
            />
            <div className="card-body px-0 pb-2 pt-0 pb-2">
              <form onSubmit={handleSubmit(onSubmit)} className="px-3 pt-3" id="strongarmRegister-form"
              >
                <div className="row">

                  <div className="col-12">
                    <div className="form-group">
                      {/* <label htmlFor="text"> {t("lastName")}</label> */}
                      {/* <input
                        type="text"
                        className={`form-control  mb-1 shadow ${errors.name ? "is-invalid" : ""
                          }`}
                        name="name"
                        id="name"
                        value={farmerName}
                        autoComplete="off"
                        placeholder="Name"
                        {...register("name", {
                          required: t("nameErrorMsg"),
                        })}
                        onChange={(e) =>
                          handleChange("name", e.target.value)
                        }
                        onKeyPress={handleKeyPress}
                      /> */}

                      <input
                        type="text"
                        className={`form-control mb-1 shadow ${errors.name ? "is-invalid" : ""
                          }`}
                        name="name"
                        id="name"
                        value={nameInput}
                        autoComplete="off"
                        placeholder="Name"
                        {...register("name", {
                          required: t("nameErrorMsg"),
                        })}
                        onChange={(e) => {
                          setNameInput(e.target.value);
                          handleChange("name", e.target.value);
                        }}
                        onKeyPress={handleKeyPress}
                      />

                      {errors.lastName && (
                        <div className="invalid-feedback">
                          {errors.lastName.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      {/* <label htmlFor="text"> {t("lastName")}</label> */}
                      <input
                        type="text"
                        className={`form-control  mb-1 shadow ${errors.mobileNumber ? "is-invalid" : ""
                          }`}
                        name="mobileNumber"
                        id="mobileNumber"
                        value={mobileNumber}
                        placeholder="Mobile Number"
                        autoComplete="off"
                        {...register("mobileNumber", {
                          required: t("mobileNumberErrorMsg"),
                        })}
                        onChange={(e) =>
                          handleChange("mobileNumber", e.target.value)
                        }
                        onKeyPress={handleKeyPress}
                      />
                      {errors.mobileNumber && (
                        <div className="invalid-feedback">
                          {errors.mobileNumber.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      {/* <label htmlFor="text"> {t("pincode")}</label> */}
                      <input
                        type="number"
                        className="form-control shadow"
                        name="pincode"
                        value={parseData?.pincode}
                        id="pincode"
                        placeholder="पिनकोड"
                        autoComplete="off"
                        maxLength={6}
                        onChange={(e) =>
                          handleChange("pincode", e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.target.value.length >= 6 && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>


                  <div className="col-12">
                    <div className="form-group">
                      {/* <label htmlFor="text"> {t("pincode")}</label> */}
                      {/* <input
                        type="number"
                        className="form-control shadow"
                        name="pincode"
                        id="pincode"
                        placeholder="खेत का अकार (एकड़ में)"
                        autoComplete="off"
                        maxLength={6}
                        onChange={(e) =>
                          handleChange("pincode", e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.target.value.length >= 6 && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }}
                      /> */}

                      <input
                        type="text"
                        inputMode="decimal"
                        pattern="[0-9.]*"
                        className={`form-control acresInput totalacres-styles shadow  mb-1 ${errors.totalAcres ? "is-invalid" : ""
                          }`}
                        placeholder={t('Total_acres')}
                        name="totalAcres"
                        id="totalAcres"
                        autoComplete="off"
                        value={totalAcres}
                        onChange={handletotalAcresInputChange}
                      />
                      {formErrors.totalAcres && <div className="text-danger">{t("total_acresErrorMsg")}</div>}

                    </div>
                  </div>


                  <div className="consent-check-text">
                    <span>{t("cortevaInfo")}</span>{" "}
                    <button
                      type="button"
                      className="consent-know-more-btn"
                      onClick={openConsentModal}
                    >
                      {t("knowmore")}
                    </button>
                  </div>

                  {/* Add similar input fields for other form fields */}
                  {/* 
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="locationInput"> {t("address")}</label>
                      <input
                        type="text"
                        className="form-control shadow"
                        {...register("location")}
                        id="locationInput"
                        autoComplete="off"
                        readOnly
                        value={address} // Display the address
                      />
                      <i className="fa fa-map-marker mapIcon"></i>
                    </div>
                  </div> */}
                </div>
                {/* <div id="map" style={{ height: "495px", width: "100%" }}>
                  <LoadScript googleMapsApiKey={REACT_APP_MAPS_API_KEY}>
                    <GoogleMap
                      mapContainerStyle={{ height: "100%", width: "100%" }}
                      center={{ lat: latitude, lng: longitude }}
                      zoom={16}
                    >
                      <Marker
                        position={{ lat: latitude, lng: longitude }}
                        draggable={true} // Make the marker draggable
                        onDragEnd={(event) => {
                          const lat = event.latLng.lat();
                          const lng = event.latLng.lng();
                          setLatitude(lat);
                          setLongitude(lng);
                          getAddressFromLatLng(lat, lng);
                        }}
                      />
                    </GoogleMap>
                  </LoadScript>
                </div> */}

                <button
                  type="submit"
                  className="btn btn-secondary w-100 py-2 center-textbtn mt-3 text-white text-uppercase btnshadow"
                  id="submitBtn">
                  {t('Submitbtn')}
                </button>
              </form>

            </div>


            <CustomModal
              id="consentDetailsModal"
              className="login-consent-modal"
              size="lg"
              title={getPrivacyConsentNotice(lang).title}
              content={<PrivacyConsentContent lang={lang} modal />}
              footer={
                <div className="consent-modal-footer-actions w-100">
                  {/* <Button
                    type="button"
                    className="rounded-4 py-2 consent-decline-btn btnshadow"
                    onClick={handleConsentDecline}
                  >
                    {t("consentDecline")}
                  </Button> */}
                  <Button
                    type="button"
                    className="rounded-4 py-2 btn-secondary w-100 btnshadow"
                    onClick={handleConsentAccept}
                  >
                    {t("close")}
                  </Button>
                </div>
              }
              show={consentModalShow}
              onHide={closeConsentModal}
            />

            {/* //genuinityCheckModal */}
            <CustomModal
              id={"genuinityCheckModal"}
              title={
                <>
                  {/* {!scanedDataObject.hasOwnProperty('isSpinDone') && (
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          onClick={handleNavigation}
                        >
                          <img src={Close} alt="Close" />
                        </button>
                      )} */}


                </>
              }
              content={
                <>
                  {/* {scanResponseData?.productName} */}
                  {/* <p className="mb-1 modalInfo" style={{ textTransform: 'capitalize' }}>
                        {t("productName")}: {apiProductName}
                      </p> */}
                  {/* <img src={scanResponseData.productImageUrl} alt="GenuityCheck" style={{ width: '100px', marginBottom: '1rem' }} /> */}

                  <div className='d-flex flex-column align-items-center' style={{ gap: '1rem' }}>
                    <img src={Check} alt='check' />
                    <img src={scanResponseData.productImageUrl} alt="GenuityCheck" style={{ width: '200px' }} />

                    {scanResponseData.primaryRewardMsg && (
                      <p className=' text-secondaryColor font-bold mb-0' dangerouslySetInnerHTML={{ __html: scanResponseData?.primaryRewardMsg }}></p>)}


                    {scanResponseData.secondaryRewardMsg && (
                      <p className='mb-0 text-sm' dangerouslySetInnerHTML={{ __html: scanResponseData?.secondaryRewardMsg }}></p>)
                    }

                    {scanResponseData.scanLimitReached && (
                      <p
                        className="genuityCheckLimitMsg text-center mb-0 px-2"
                        dangerouslySetInnerHTML={{
                          __html: scanLimitNotice.replace(/\r\n|\n|\r/g, "<br />"),
                        }}
                      />
                    )}
                  </div>


                  {/* {scanResponseData.isAlreadyScannedProduct && (
                      <>
                        <p className={`${!productID ? 'mt-10' : ''} mb-2 modalInfo text-danger pt-2`} dangerouslySetInnerHTML={{ __html: scanResponseData?.primaryRewardMsg }}>
                        </p>
                      </>
                    )} */}
                </>
              }
              footer={
                <div className="genuityCheckModalFooter w-100">
                  {/* <Button
                      className="w-100 rounded-4 py-2 btn-secondary"
                      onClick={handleGenuityScanMore}
                    >
                      {t("Scanmore")}
                    </Button> */}
                  {!scanResponseData.scanLimitReached && (
                    <Button
                      className="w-100 rounded-4 py-2 btn-secondary btnshadow"
                      onClick={handleGenuityProceedCashback}
                    >
                      {t("genuityCheck.proceedToCashback")}
                    </Button>
                  )}
                </div>
              }
              show={GenunityCheckModal}
              onHide={() => setGenunityCheckModal(false)}
            />

            {/*///not genuine case */}
            <CustomModal
              id={"genuinityCheckModalError"}
              title={
                <>
                  {/* <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => {
                          setErrorModalGenunity(false);
                          handleNavigation();
                        }}
                      >
                        <img src={Close} alt="Close" />
                      </button> */}

                  {/* {t("genuityCheck")} */}

                </>
              }

              content={
                <>
                  <img src={Wrongotp} alt='Wrongotp' className='img-fluid my-4' />

                  {/* <p className="mb-1 modalInfo">{t("serialNO")}: {scanResponseData.prodSerialNumber}</p> */}
                  {/* {scanErrorResponseData?.productName && (
                      <p className="mb-1 modalInfo">
                        {t("productName")}: {apiProductName}
                      </p>
                    )} */}

                  {/* <img src={apiProductName.toLowerCase().includes("delegate") ? GenuityCheckDelegate : GenuityCheckTracer} alt="GenuityCheck" style={{ width: '100px' }} /> */}
                  {/* <img src={Packet} alt="GenuityCheck" style={{ width: '200px', margin: '1.5rem 0rem 4rem 0rem' }} />
                    <img src={Not_Genuine} alt="Not_Genuine" className="notGenuine_corteva_product" /> */}

                  {/* {scanResponseData?.uq_message && (
                      <p className="mb-0 modalInfo">
                        {scanResponseData?.uq_message}
                      </p>
                    )} */}

                  {scanResponseData.primaryRewardMsg && (
                    <p style={{ fontWeight: '600', color: '#000000', textAlign: 'center' }}>
                      {scanResponseData?.primaryRewardMsg}
                    </p>
                  )}
                  {scanResponseData.secondaryRewardMsg && (
                    <p style={{ fontWeight: '400', color: '#000000', textAlign: 'center' }} >
                      {scanResponseData?.secondaryRewardMsg}
                    </p>
                  )}




                </>
              }
              footer={
                <>
                  <div className="d-flex justify-content-between w-100" style={{ gap: '.5rem' }}>
                    {/* <Button
                        className="w-100 rounded-4 py-2 btn-secondary" onClick={() => {
                          navigate(`/${lang}/`)
                        }}>
                        {t("Done")}
                      </Button> */}

                    <Button
                      className="w-100 rounded-4 py-2  btn-primary" onClick={() => {
                        ReactGA.event({
                          category: 'User Scan More',
                          action: 'Clicked the Scan More Button',
                        });
                        navigate(`/${lang}/scanProduct`)
                      }}>
                      {/* {t("Scanmore")} */}
                      {t('scanAgain')}
                    </Button>
                  </div>

                </>

              }
              show={ErrorModalGenunity}
              onHide={() => setErrorModalGenunity(false)}
            />


            {errorMessage && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-2"
                role="alert"
              >
                {errorMessage}
                <button
                  type="button"
                  className="close"
                  onClick={hide}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

    </>
  );
};

export default Register;
